import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';

import { ApplicationAliases, FragmentNames } from '../codegen';
import { ThemeService, ThemeTonalRange } from '@philips-internal/oswald-ui-components/lib/services';

@Controller({ fragment: FragmentNames.APPLICATION })
export default class ApplicationController {

  @OnMount({ target: ApplicationAliases.MAIN_APPLICATION })
  onMainApplicationMount(): void {
    ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);

    // OSWALD V6. User does cptest not have acces to this module
    // applicationContext.openModule('dashboard');
  }
}
